/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import CourseRequestsIcon from 'icons/CourseRequestsIcon';

const messages = defineMessages({
  title: {id: 'navigation.pd-approval-queue'},
});

const PdApprovalQueueItem = () => (
  <RouteLinkItem
    iconBefore={CourseRequestsIcon}
    route="midas/staff/pd-approval-queue"
    title={messages.title}
  />
);

export default PdApprovalQueueItem;
